import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTrophy, FaCode, FaUsers, FaLightbulb, FaCertificate, FaExternalLinkAlt, FaTimes } from 'react-icons/fa';
import './Achievements.css';

const Achievements = () => {
  const [selectedCert, setSelectedCert] = useState(null);

  const achievements = [
    {
      title: 'Code for Bharat',
      description: 'Pre-finalist in Code for Bharat Hackathon competition',
      icon: <FaCode />,
      date: '2025',
      certificate: 'codeforbharat.jpg', // add certificate URL or image path here
    },
    {
      title: 'CodeClash 2.0',
      description: 'Selected for Top Ideas and presented MVP',
      icon: <FaLightbulb />,
      date: '2025',
      certificate: 'CodeClash.jpg',
    },
    {
      title: 'GSSoC 2025',
      description: 'Open source contributor at GirlScript Summer of Code',
      icon: <FaTrophy />,
      date: '2025',
      certificate: 'GSSOC.png',
    },
    {
      title: 'OSCI 2025',
      description: 'Open source contributor',
      icon: <FaTrophy />,
      date: '2025',
      certificate: 'osci.png',
    },

      {
      title: 'Meta Code IIT KGP',
      description: 'Qualified Round 1 ',
      icon: <FaTrophy />,
      date: '2026',
      certificate: 'ii.jpeg',
    },
    {
      title: 'SheCode Workshop',
      description: 'Participated in SheCode empowerment workshop and contributed on Live project',
      icon: <FaUsers />,
      date: '2026',
      certificate: 'code.png',
    },
  ];

  return (
    <section id="achievements" className="achievements">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Achievements & Participation</h2>
          <div className="underline"></div>
        </motion.div>

        <div className="achievements-grid">
          {achievements.map((item, index) => (
            <motion.div
              key={item.title}
              className="achievement-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -6 }}
            >
              {/* Top row: icon + date */}
              <div className="card-top">
                <div className="achievement-icon">{item.icon}</div>
                <span className="achievement-date">{item.date}</span>
              </div>

              {/* Details */}
              <div className="achievement-details">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>

              {/* Certificate */}
              <div className="certificate-row">
                {item.certificate ? (
                  <button
                    className="cert-btn cert-btn--view"
                    onClick={() => setSelectedCert(item)}
                  >
                  
                    <span>View Certificate</span>
                  </button>
                ) : (
                  <span className="cert-btn cert-btn--none">
                    <FaCertificate />
                    <span>No Certificate</span>
                  </span>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Certificate Modal */}
      <AnimatePresence>
        {selectedCert && (
          <motion.div
            className="cert-modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedCert(null)}
          >
            <motion.div
              className="cert-modal"
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 260, damping: 22 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-close" onClick={() => setSelectedCert(null)}>
                <FaTimes />
              </button>
              <h3>{selectedCert.title}</h3>
              <div className="cert-preview">
                {selectedCert.certificate.endsWith('.pdf') ? (
                  <iframe
                    src={selectedCert.certificate}
                    title={`${selectedCert.title} certificate`}
                  />
                ) : (
                  <img src={selectedCert.certificate} alt={`${selectedCert.title} certificate`} />
                )}
              </div>
              <a
                href={selectedCert.certificate}
                target="_blank"
                rel="noopener noreferrer"
                className="cert-external"
              >
                <FaExternalLinkAlt /> Open in new tab
              </a>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Achievements;